import { FilterItem } from '@framework/types';
import { API_ENDPOINTS } from '@framework/utils/api-endpoints';
import { useQuery } from '@tanstack/react-query';
import http from '@framework/utils/http';

export const fetchManufacturersFilter = async () => {
  const { data } = await http.get(API_ENDPOINTS.MANUFACTURERS_FILTER);

  return data.data;
};
export const useFetchManufacturersFilter = () => {
  return useQuery<FilterItem[], Error>({
    queryKey: [API_ENDPOINTS.MANUFACTURERS_FILTER],
    queryFn: fetchManufacturersFilter,
  });
};
